import './App.css';
import DepositLocker from './Components/DepositLocker';

function App() {
  return (
   <div>
   <DepositLocker/>
   </div>
  );
}


export default App;
